import styled from "styled-components";
import {styledByDevice} from "../../../../themes/architecture/styled-by-device";

const DefaultBox = styled.h1`
  font-weight: 300;
  font-family: ${props => props.theme.font.family.medium};
  color: ${props => props.theme.colors.arenaTitle};
`;

const PCBox = styled(DefaultBox)`
  font-size: 2rem;
  text-transform: capitalize;
`;

const MobileBox = styled(DefaultBox)`
  font-size: 1.8rem;

  @media ${({theme}) => theme.mediaQuery.sAndBelow} {
    font-size: 1.2rem;
  }
`;

export const TopBannerTitleDefaultBox = styledByDevice(PCBox, MobileBox);